module.exports = __webpack_public_path__ + "static/media/megaphone.742ef437.svg";